<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>{{cardTitle}}</mat-panel-title>
    <mat-icon class="_common-indicator">expand_more</mat-icon>
  </mat-expansion-panel-header>
  <div>
    <ng-content></ng-content>
  </div>
</mat-expansion-panel>
